import React, { useContext } from 'react'
import { PanelDeControlContext } from '../../../context/PanelDeControlContext'
import useForm from '../../../hooks/useForm';
import apiEventos from '../../../services/apis/apiEventos';
import { types } from '../../../types/types';

const MenuEditarEvento = ({ alternarMenuEdicion }) => {

    const { eventoSeleccionado: evento, setEventoSeleccionado, dispatchEventos } = useContext( PanelDeControlContext );
    const { values, handleInputChange } = useForm({ nombre: '' })
    const { nombre } = values;

    const editarEvento = async() => {

        const eventoActualizado = { ...evento, nombre }

        // Editar en base de datos
        const response = await apiEventos.put( eventoActualizado );
        if( response.error ){ return console.log( response.errorMsg )}

        // Actualizar en vista
        dispatchEventos({type: types.eventoEditado, payload: eventoActualizado });
        setEventoSeleccionado( eventoActualizado );
        alternarMenuEdicion();

    }

    return (
        <div className='menu-edicion'>

            <h3>Editar evento: <small>{ evento.nombre }</small></h3>

            <form>
                <label htmlFor="nombre" className='form-label' >Nombre del Evento</label>
                <input className='form-control'
                    type="text" name="nombre" id="nombre_evento" 
                    value={ nombre } onChange={ handleInputChange }/>
            </form>

            <div className="row justify-content-end gx-1 mt-3">
                <div className="col-auto">
                    <button className="btn btn-secondary" onClick={ alternarMenuEdicion } >Cancelar</button>
                </div>
                <div className="col-auto">
                    <button className="btn btn-primary" onClick={ editarEvento } >Guardar cambios</button>
                </div>
            </div>

        </div>
    )
}

export default MenuEditarEvento
